import { getMatches } from "./chunk-KROBAS26.js";

// src/hooks/use-media-query.ts
import { useEffect, useState, useCallback } from "react";
var useMediaQuery = query => {
  const [matches, setMatches] = useState(void 0);
  const handleChange = useCallback(() => setMatches(getMatches(query)), [setMatches, query]);
  useEffect(() => {
    const matchMedia = window.matchMedia(query);
    handleChange();
    if (matchMedia.addListener) {
      matchMedia.addListener(handleChange);
    } else {
      matchMedia.addEventListener("change", handleChange);
    }
    return () => {
      if (matchMedia.removeListener) {
        matchMedia.removeListener(handleChange);
        return;
      }
      matchMedia.removeEventListener("change", handleChange);
    };
  }, [handleChange, query]);
  return matches;
};
var use_media_query_default = useMediaQuery;
export { use_media_query_default };